export default __webpack_public_path__ + "static/media/razorpay.f31107b3.svg";